import { helper as buildHelper } from '@ember/component/helper';

/**
 * This function will take any callable function, and will call it expecting a boolean response.
 *
 * @param params
 * @return {Boolean}
 */
export function isCallableTrue(params/*, hash*/) {
  if (!params[0] || typeof params[0] !== 'function') {
    return false;
  }

  return params[0]();
}

export default buildHelper(isCallableTrue);
